import { Typography, Button } from "@mui/material";
import { get } from "lodash";
import moment from "moment";
import {
  Datagrid,
  FunctionField,
  Identifier,
  List,
  RaRecord,
  sanitizeFieldRestProps,
  ShowButton,
  TextField,
  useRecordContext,
  useRefresh,
} from "react-admin";
import { UserType } from "../../enums/common";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { PaymentStatusEnum } from "../../enums/PaymentStatusEnum";
import {
  PlatformLeadProductType,
  PlatformLeadStatus,
} from "../../enums/PlatformLeadEnums";
import EventBus from "../../EventBus";
import PlatformLeadServices from "../../services/PlatformServices";
import CallButton from "../Common/CallButton/CallButton";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import CommonFilterCard, { CommonFilterField } from "../Common/CommonFilterCard";
import StyledDatagridWrapper, { commonDatagridSx } from "../Common/StyledDatagridWrapper";

const platformLeadServices = new PlatformLeadServices();

const filterFields: CommonFilterField[] = [
  {
    type: "select",
    label: "Product",
    source: "product",
    options: Object.values(PlatformLeadProductType).map((key) => ({
      value: key,
      label: key,
    })),
  },
  { type: "text", label: "Customer Mobile", source: "mobile" },
  { type: "text", label: "ClientId", source: "clientId" },
  { type: "date", label: "Start Date", source: "startDate" },
  { type: "date", label: "End Date", source: "endDate" },
  {
    type: "select",
    label: "Status",
    source: "status",
    options: Object.values(PlatformLeadStatus).map((key) => ({
      value: key,
      label: key,
    })),
  },
  {
    type: "select",
    label: "Payment Status",
    source: "paymentStatus",
    options: Object.values(PaymentStatusEnum).map((key) => ({
      value: key,
      label: key,
    })),
  },
];

const CustomArrayField = (props: any) => {
  const { className, source, emptyText, objMap, ...rest } = props;
  const record = useRecordContext(props);
  let value;
  if (source) {
    value = get(record, source);
    if (value && value.length > 0) {
      return (
        <div style={{ display: "flex", gap: "4px" }}>
          {value.map((x: any, index: number) => (
            <Typography
              component="span"
              variant="body2"
              key={x + index}
              className={className}
              {...sanitizeFieldRestProps(rest)}
            >
              {objMap
                ? objMap[x]
                : x != null && typeof x !== "string"
                ? JSON.stringify(x)
                : x + "," || emptyText}
            </Typography>
          ))}
        </div>
      );
    } else {
      return <></>;
    }
  }
  return <></>;
};
const PlatformLeadList = () => {
  const refresh = useRefresh();
  const sendPaymentLinkHandler = async (id:Identifier) => {
    try{
      const response = await platformLeadServices.sendPlatformPaymentLink(id as number);
      if(response.status === 200){
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Payment link Sent",
          type: CustomSnackbarTypes.SUCCESS,
        });
      }
      refresh();
    }catch(error){
      console.error(error);
    }
  }
  return (
    <List
      sx={{
        "& .RaList-content": {
          boxShadow: "none",
          backgroundColor: "transparent",
        },
      }}
    >
      <>
      <CommonFilterCard fields={filterFields} />

      <br />

      <StyledDatagridWrapper title="Platform">
      <Datagrid bulkActionButtons={false} size="medium" sx={commonDatagridSx}>
        <TextField label="ID" source="id" />
        <TextField label="Name" source="name" />
        <FunctionField
          label="Mobile"
          render={(record: any) => (
            <CallButton
              toPhoneNumber={record?.mobile}
              userType={UserType.COOK}
            />
          )}
        />
        <TextField label="Email" source="email" />
        <TextField label="Customer Id" source="customerId" />
        <TextField label="Client ID" source="clientId" />
        <TextField label="Product" source="product" />
        <TextField label="Status" source="status" />
        <CustomArrayField
          textAlign="center"
          label="Requirement"
          source="requirements"
        ></CustomArrayField>
        <TextField label="Total People" source="totalPeople" />
        <FunctionField label="Date" render={(record: any) => record?.date ? moment(record.date).format('DD MMM YYYY') : '-'} />
        <TextField label="Area ID" source="areaId" />
        <TextField label="Area Name" source="areaName" />
        <TextField label="City ID" source="cityId" />
        <TextField label="City Name" source="cityName" />
        <TextField label="Locality Id" source="localityId" />
        <TextField label="Localoty Name" source="localityName" />
        <TextField label="Allocator Id" source="allocatorId" />
        <TextField label="Allocator Email" source="allocatorEmail" />
        <TextField source="createdAt" />
        <FunctionField label="Show" render={() => <ShowButton />} />
        <FunctionField
          render={(record: RaRecord) => {
            return (
              <>
                {record?.paymentStatus === PaymentStatusEnum.NOT_PAID ? (
                  <Button onClick={async ()=>{sendPaymentLinkHandler(record.id)}} variant="text" size="small" color="primary">
                    Send Payment Link
                  </Button>
                ) : null}
              </>
            );
          }}
        />
      </Datagrid>
      </StyledDatagridWrapper>
      </>
    </List>
  );
};

export default PlatformLeadList;
